import { render, staticRenderFns } from "./AddVideoCourses.vue?vue&type=template&id=0afef5a2&scoped=true"
import script from "./AddVideoCourses.vue?vue&type=script&lang=js"
export * from "./AddVideoCourses.vue?vue&type=script&lang=js"
import style0 from "./AddVideoCourses.vue?vue&type=style&index=0&id=0afef5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afef5a2",
  null
  
)

export default component.exports